/**
 * @generated SignedSource<<da99bb61cd437cca48306a2284f09fbf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionList_viewer$data = {
  readonly publicProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionListTile_publicProfile">;
  } | null;
  readonly tokenImports: {
    readonly edges: ReadonlyArray<{
      readonly collection: {
        readonly incompleteItems: {
          readonly totalResults: number | null;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionListTile_contractImport" | "importCollectionsConfig_contractImport">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "NftProfileImportCollectionList_viewer";
};
export type NftProfileImportCollectionList_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionList_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalResults",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionList_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*:: as any*/)
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftProfileImportCollectionListTile_publicProfile"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "tokenImports",
      "args": [
        {
          "kind": "Variable",
          "name": "creatorAddress",
          "variableName": "walletAddress"
        },
        (v0/*:: as any*/)
      ],
      "concreteType": "NftTokenContractImportsConnection",
      "kind": "LinkedField",
      "name": "nftTokenContractImports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImportsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": "collection",
              "args": null,
              "concreteType": "NftTokenContractImport",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": "incompleteItems",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "importStatuses",
                      "value": [
                        "NFT_ITEM_IMPORT_STATUS_ERROR",
                        "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                      ]
                    }
                  ],
                  "concreteType": "NftTokenContractImportCreatedItemsConnection",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": false,
                  "selections": (v2/*:: as any*/),
                  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "importCollectionsConfig_contractImport",
                  "selections": [
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importStatus",
                      "storageKey": null
                    },
                    {
                      "alias": "errored",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_ERROR"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v2/*:: as any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                    },
                    {
                      "alias": "processing",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v2/*:: as any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                    },
                    {
                      "alias": "completed",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v2/*:: as any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftProfileImportCollectionListTile_contractImport"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "eaec4b0c2bf66bdebce2c7e78e51559a";

export default node;
